import { ChangeEvent, FC, HTMLProps, useState } from 'react'

import clsx from 'clsx'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'

import s from './styles.module.scss'

interface Props extends Omit<HTMLProps<HTMLInputElement>, 'size'> {
  onReset?: () => void
  size?: 'medium' | 'large'
  rootClassName?: string
}

export const SearchInput: FC<Props> = ({
  onChange,
  onReset,
  size = 'medium',
  rootClassName,
  ...props
}) => {
  const [search, setSearch] = useState<string>()

  const onSearch = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event)

    setSearch(event?.currentTarget?.value)
  }

  const onResetValue = () => {
    setSearch('')
    onReset?.()
  }

  return (
    <div
      className={clsx(
        s.container,
        size === 'large' && s.containerLarge,
        rootClassName,
      )}
    >
      <label
        htmlFor="searchInput"
        className={clsx(s.wrapperIcon, size === 'large' && s.wrapperIconLarge)}
      >
        <AppIcon
          id={AllIcons.MAGNIFIER}
          className={clsx(s.icon, size === 'large' && s.iconLarge)}
          color="var(--grey-3)"
        />
      </label>

      <input
        id="searchInput"
        value={search}
        className={clsx(s.input, size === 'large' && s.inputLarge)}
        onChange={onSearch}
        {...props}
      />

      {search?.length ? (
        <AppIcon
          className={clsx(s.cross, size === 'large' && s.crossLarge)}
          onClick={onResetValue}
          id={AllIcons.CROSS_BOLD}
        />
      ) : null}
    </div>
  )
}
